import { render, staticRenderFns } from "./comp_createSeal.vue?vue&type=template&id=6e030709&"
import script from "./comp_createSeal.vue?vue&type=script&lang=js&"
export * from "./comp_createSeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports